import { PRODUCT_FEATURES } from '@hoedokloop/feature-policy';
import { z } from '@hono/zod-openapi';

import { InstantSchema } from './common';

export const FeatureModeSchema = z.enum(['disabled', 'enabled', 'maintenance']);
export const ProductFeatureSchema = z.enum(PRODUCT_FEATURES);
export const EntitlementStatusSchema = z.enum(['active', 'expired', 'refunded', 'revoked']);

export const FeatureConfigSchema = z
  .object({
    version: z.number().int().positive(),
    updatedAt: InstantSchema,
    features: z.array(
      z.object({ feature: ProductFeatureSchema, mode: FeatureModeSchema }).strict(),
    ),
  })
  .strict()
  .superRefine((value, context) => {
    if (new Set(value.features.map((entry) => entry.feature)).size !== value.features.length) {
      context.addIssue({ code: 'custom', path: ['features'], message: 'Duplicate feature' });
    }
  })
  .openapi('FeatureConfig');

export const EntitlementSnapshotSchema = z
  .object({
    status: EntitlementStatusSchema,
    productId: z.string().min(1).max(100),
    verifiedAt: InstantSchema,
    startsAt: InstantSchema,
    expiresAt: InstantSchema,
    offlineGraceUntil: InstantSchema,
    lastObservedAt: InstantSchema,
  })
  .strict()
  .openapi('EntitlementSnapshot');

export const EntitlementResponseSchema = z
  .object({
    entitlement: EntitlementSnapshotSchema.nullable(),
    featureConfig: FeatureConfigSchema,
  })
  .strict()
  .openapi('EntitlementResponse');

export type FeatureConfig = z.infer<typeof FeatureConfigSchema>;
export type EntitlementResponse = z.infer<typeof EntitlementResponseSchema>;
